import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ActiveSession {
  id: string;
  auth_type: 'local' | 'sso';
  device_type: string;
  os_name: string | null;
  browser_name: string | null;
  ip_address: string | null;
  created_at: string;
  last_active_at: string;
  revoked_at: string | null;
  is_current: boolean;
}

export interface RevokeOthersResult {
  detail: string;
  revoked_count: number;
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.baseApiUrl + 'user/v1/sessions';

  list(): Observable<ActiveSession[]> {
    return this.http.get<ActiveSession[]>(this.base);
  }

  establish(): Observable<ActiveSession> {
    return this.http.post<ActiveSession>(`${this.base}/establish`, {});
  }

  revoke(id: string): Observable<{ detail: string; id: string }> {
    return this.http.delete<{ detail: string; id: string }>(`${this.base}/${id}`);
  }

  revokeOthers(): Observable<RevokeOthersResult> {
    return this.http.post<RevokeOthersResult>(`${this.base}/revoke-others`, {});
  }
}
